/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import styled from 'styled-components';
import styles from '../../../styles';

const colors = (p) => {
  switch (p.severity) {
    case 'healthy': return styles.colors.ssGreen;
    case 'maintenance': return styles.colors.ssPurple;
    case 'neutral': return styles.colors.geyser;
    default: return '';
  }
};

export const Wrapper = styled.div`
  border: 1px solid ${styles.colors.geyser};
  border-left: 3px solid ${colors};
  margin-bottom: 0.5rem;
  padding: 1rem;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  @media (max-width: 480px) {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 0;
  }
`;

export const Title = styled.span`
  ${styles.fonts.headingLabelCaps}
  letter-spacing: 1px;
  line-height: 1.33;
  vertical-align: middle;
`;

export const TimeStamp = styled.div.attrs({
    className: "slds-badge"
})`
  background-color: initial;
  border: 1px solid ${colors};
  color: ${colors};
  line-height: 1.3;
  vertical-align: middle;
  @media (max-width: 480px) {
    margin: 0.75rem 0;
  }
`;

export const Body = styled.div`
  ${styles.fonts.base}
  color: ${styles.colors.biscay};
  letter-spacing: 0px;
`;

export const Duration = styled.div`
  ${styles.fonts.base}
  color: ${colors};
`;

export const FooterTimeStamp = styled.div`
  ${styles.fonts.footerLabel}
  margin-top: 0.75rem;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }
`;